import { Icon } from "@iconify/react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useRef, useState } from "react";
import editFill from "@iconify/icons-eva/edit-fill";
import { Link as RouterLink } from "react-router-dom";
import activityOutline from "@iconify/icons-eva/activity-outline";
import moreVerticalFill from "@iconify/icons-eva/more-vertical-fill";
import deleteOutline from "@iconify/icons-eva/trash-2-outline";
// material
import {
  Menu,
  MenuItem,
  IconButton,
  ListItemIcon,
  ListItemText,
  FormControl,
  InputLabel,
  Select,
  TextField,
  Alert,
  AlertTitle,
} from "@mui/material";
import { doc, updateDoc, deleteDoc } from "firebase/firestore";
import { db } from "../../../Firebase/firebase";

// ----------------------------------------------------------------------

// Modal Styles
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 400,
  bgcolor: "background.paper",
  border: "none",
  borderRadius: "5px",
  boxShadow: 24,
  p: 4,
  display: "flex",
  flexDirection: "column",
};

export default function UserMoreMenu3({
  uid,
  orderId,
  stageId,
  City,
  details,
  heading,
}) {
  const [orderCity, setOrderCity] = useState(City);
  const [orderDetails, setOrderDetails] = useState(details);
  const [orderHeading, setOrderHeading] = useState(heading);
  const [updateButton, setUpdateButton] = useState("Update");
  const [updateAlert, setUpdateAlert] = useState("");
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  // Modal states

  const [open, setOpen] = useState(false);

  const handleUpdate = async () => {
    setUpdateButton("Loading...");
    const adminRef = doc(
      db,
      "users",
      uid,
      "orders",
      orderId,
      "details",
      stageId
    );
    await updateDoc(adminRef, {
      City: orderCity,
      details: orderDetails,
      heading: orderHeading,
    })
      .then(() => {
        setUpdateButton("Update");
        setUpdateAlert("Broker details has been updated");
      })
      .catch((err) => {
        console.log(err.message);
        setUpdateButton("Update");
      });
  };
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setUpdateAlert("");
    setOrderCity(City);
    setOrderDetails(details);
    setOrderHeading(heading);
  };

  const handleDelete = async () => {
    if (window.confirm("Are you sure you want to delete this stage?")) {
      const stageRef = doc(
        db,
        `users/${uid}/orders/${orderId}/details`,
        stageId
      );
      await deleteDoc(stageRef)
        .then(() => {
          setIsOpen(false);
        })
        .catch((err) => {
          console.error("Error deleting stage:", err);
          alert("Error deleting stage");
        });
    }
  };

  return (
    <>
      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: "100%" },
        }}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem
          component={RouterLink}
          to="#"
          sx={{ color: "text.secondary" }}
          onClick={handleOpen}
        >
          <ListItemIcon>
            <Icon icon={editFill} width={24} height={24} />
          </ListItemIcon>
          <ListItemText
            primary="Edit"
            primaryTypographyProps={{ variant: "body2" }}
          />
        </MenuItem>
        <MenuItem sx={{ color: "error.main" }} onClick={handleDelete}>
          <ListItemIcon>
            <Icon icon={deleteOutline} width={24} height={24} />
          </ListItemIcon>
          <ListItemText
            primary="Delete Stage"
            primaryTypographyProps={{ variant: "body2" }}
          />
        </MenuItem>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <Box component="form" sx={style} noValidate autoComplete="off">
              <div style={{ margin: "0 0 5px 0", textAlign: "center" }}>
                {updateAlert && (
                  <Alert severity="success">
                    <AlertTitle>Success</AlertTitle>
                    {updateAlert}
                  </Alert>
                )}

                <TextField
                  label="City"
                  style={{ margin: "0 0 10px 0", width: "90%" }}
                  onChange={(e) => setOrderCity(e.target.value)}
                />
                <TextField
                  label="Heading"
                  style={{ margin: "0 0 10px 0", width: "90%" }}
                  onChange={(e) => setOrderHeading(e.target.value)}
                />
                <TextField
                  label="Details"
                  style={{ margin: "0 0 10px 0", width: "90%" }}
                  onChange={(e) => setOrderDetails(e.target.value)}
                />
              </div>

              <Button
                variant="contained"
                disabled={updateButton === "Update" ? false : true}
                onClick={() => handleUpdate()}
              >
                {updateButton}
              </Button>
            </Box>
          </Fade>
        </Modal>
      </Menu>
    </>
  );
}
